import { Injectable } from '@angular/core';
import { DataTransformAbstractGet } from 'app/modules/global/classes/data.transform.abstract.up';
import { CustomerInterface } from 'app/models/customer.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerDataTransformGet extends DataTransformAbstractGet {
  transform(customer: CustomerInterface): CustomerInterface {
    return customer;
  }
}
